import { render, staticRenderFns } from "./DistributionReservationItem.vue?vue&type=template&id=4d686df3&scoped=true&"
import script from "./DistributionReservationItem.vue?vue&type=script&lang=js&"
export * from "./DistributionReservationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d686df3",
  null
  
)

export default component.exports